import { Link } from "react-router-dom";

const WHATSAPP_URL = "https://wa.me/5547992561262?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento.";

const QUICK_LINKS = [
  { label: "Início", to: "/" },
  { label: "Sobre Nós", to: "/sobre" },
  { label: "Serviços", to: "/servicos" },
  { label: "Portfólio", to: "/#portfolio" },
  { label: "Contato", to: "/#contato" },
];

const SERVICES_LINKS = [
  "Projetos para Construção",
  "Regularização de Construções",
  "Design de Interiores",
  "Design de Fachadas",
  "Maquetes Eletrônicas",
  "Financiamento de Imóveis",
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: "#121212" }} className="text-white pt-16 pb-6">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-12 border-b border-white/10">
          {/* Col 1 - Brand */}
          <div>
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/9dd974b3e895b7f64206723b1ef41387.png"
              alt="Construlife"
              className="h-12 w-auto object-contain mb-5"
            />
            <p className="text-[#7A7A7A] text-sm leading-relaxed mb-4">
              Especialistas em engenharia e arquitetura, transformando projetos em realidade com técnica, inovação e compromisso.
            </p>
            <p className="text-[#7A7A7A] text-xs">CNPJ: 50.544.010/0001-66</p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://instagram.com/construlifeprojetos"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#2563EB] hover:bg-[#1E3A8A] transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-base" />
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#2563EB] hover:bg-[#1E3A8A] transition-colors cursor-pointer"
              >
                <i className="ri-whatsapp-line text-base" />
              </a>
              <a
                href="mailto:construlifeprojetos@gmail.com"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#2563EB] hover:bg-[#1E3A8A] transition-colors cursor-pointer"
              >
                <i className="ri-mail-line text-base" />
              </a>
            </div>
          </div>

          {/* Col 2 - Links */}
          <div>
            <h4 className="text-white font-semibold text-[16px] mb-5">
              <a href="#" className="hover:text-[#C9A24A] transition-colors">Links Rápidos</a>
            </h4>
            <ul className="flex flex-col gap-3">
              {QUICK_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-[#7A7A7A] hover:text-white text-sm transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-[#C9A24A]" />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 - Serviços + Contato */}
          <div>
            <h4 className="text-white font-semibold text-[16px] mb-5">
              <a href="#" className="hover:text-[#C9A24A] transition-colors">Serviços</a>
            </h4>
            <ul className="flex flex-col gap-3 mb-8">
              {SERVICES_LINKS.map((s) => (
                <li key={s} className="text-[#7A7A7A] text-sm flex items-center gap-2">
                  <i className="ri-checkbox-blank-circle-fill text-[#C9A24A] text-[6px]" />
                  {s}
                </li>
              ))}
            </ul>
            <div className="flex flex-col gap-2">
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-[#7A7A7A] hover:text-white text-sm flex items-center gap-2 cursor-pointer">
                <i className="ri-phone-line text-[#C9A24A]" /> (47) 99256-1262
              </a>
              <a href="mailto:construlifeprojetos@gmail.com" className="text-[#7A7A7A] hover:text-white text-sm flex items-center gap-2 cursor-pointer">
                <i className="ri-mail-line text-[#C9A24A]" /> construlifeprojetos@gmail.com
              </a>
              <p className="text-[#7A7A7A] text-sm flex items-start gap-2">
                <i className="ri-map-pin-line text-[#C9A24A] mt-0.5" />
                Rua Soldado Moacir Pinheiro nº 279 Apto 301
              </p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[#7A7A7A] text-xs">
            © {currentYear} Construlife Engenharia e Arquitetura — Todos os direitos reservados.
          </p>
          <p className="text-[#7A7A7A] text-xs">
            Desenvolvido por{" "}
            <a
              href="https://startdigital1.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#C9A24A] hover:text-white transition-colors cursor-pointer"
            >
              Start Digital
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
